// extracted by mini-css-extract-plugin
module.exports = {"small_statistics_container":"SmallStatistics_small_statistics_container__RMMjf","button_switch":"SmallStatistics_button_switch__3AgxX","active":"SmallStatistics_active__dF97n"};